import { render } from "./sideMenuSpecimen.vue?vue&type=template&id=3ec99c33"
import script from "./sideMenuSpecimen.vue?vue&type=script&lang=js"
export * from "./sideMenuSpecimen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__